import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AutoLoginComponent } from './autologin/autologin.component';
import { Layout1Component } from './layout/open_layout.component';
import {NewsletterViewComponent} from './newsletter_view/newsletterview.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SignupComponent } from './signup/signup.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';


export const APP_ROUTES: Routes = [
 
  
   { path: 'login', component: AutoLoginComponent },

  //  { path: 'login', component: LoginComponent},

  { path: 'vlogin', component: LoginComponent},
  

  { path: 'autologin', component: LoginComponent },
  { path: 'vforgot', component: ForgotPasswordComponent },
  { path: 'vregister', component: SignupComponent },
  { path: 'vresetpassword', component: ResetPasswordComponent },

  {
    path: 'send_newsletter/:id/:token',component: NewsletterViewComponent
  },
  {
    path: 'send_newsletter/:id/view',component: NewsletterViewComponent
  },
 
  // {
  //   path: 'newsletter/:id/view',
  //   component: Layout1Component,
  //   children: [

  //              { path: '', redirectTo: 'newsletter', pathMatch: 'full' },

  //              {
  //                path: '', component: NewsletterViewComponent,                         
              
  //              },
        
    
  //             ]
  //  },

   { path: '', redirectTo: 'login', pathMatch: 'full' },
   { path: '**', redirectTo: '', pathMatch: 'full' },
 

   ];
